import { useEffect, useState } from "react";
export function useReactPath() {
    const [path, setPath] = useState(typeof window !== "undefined" ? window.location.pathname : "");
    function popStateHandler() {
        return () => {
            const winPath = window.location.pathname;
            setPath(winPath);
        };
    }
    useEffect(() => {
        window.addEventListener("popstate", popStateHandler());
        return () => {
            window.removeEventListener("popstate", popStateHandler());
        };
    }, []);
    return path;
}
